export const brandKeys = {
  all: (orgId?: string) => ['brands', orgId] as const,
  detail: (orgId?: string, id?: string) => ['brands', orgId, id] as const,
  withActiveFilter: (orgId?: string) => ['brands-with-active-filter', orgId] as const,
  metrics: (orgId?: string, brandId?: string) => ['brand-metrics', brandId, orgId] as const,
  allMetrics: (orgId?: string) => ['all-brand-metrics', orgId] as const,
  dashboard: (orgId?: string) => ['dashboard-brands', orgId] as const,
  legacyBrands: () => ['brands'] as const,
};
